import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '@structural-climbing/auth'
import { NewsManager } from '@structural-climbing/ui'
import { PageHeader } from '../components/PageHeader'
import { useGymContext } from '../contexts/GymContext'
import { AttendeesList } from '../features/news/AttendeesList'
import { MemberProfileModal } from '../features/members/MemberProfileModal'

export function NewsPage() {
  const { getAccessTokenSilently } = useAuth()
  const { t } = useTranslation()
  const gym = useGymContext()
  const apiUrl = import.meta.env.VITE_API_URL as string
  const [profileUserId, setProfileUserId] = useState<string | null>(null)

  return (
    <>
      <NewsManager
        apiUrl={apiUrl}
        getToken={getAccessTokenSilently}
        t={t}
        scope="gym"
        gymId={gym.gymId}
        renderHeader={(openCreate) => (
          <PageHeader
            title={t('news.managePageTitle')}
            primaryAction={{ label: t('news.addButton'), onPress: openCreate }}
          />
        )}
        renderAttendees={(newsId) => <AttendeesList newsId={newsId} onSelect={setProfileUserId} />}
      />
      {profileUserId && (
        <MemberProfileModal userId={profileUserId} onClose={() => setProfileUserId(null)} />
      )}
    </>
  )
}
